import {
  Crop as CropIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Lock,
  LockOpen,
  MoreHoriz as MoreIcon,
} from "@mui/icons-material";
import { IconButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import type { FC } from "react";
import { useState } from "react";

interface Props {
  readonly isPrivate: boolean;
  readonly onEdit?: () => void;
  readonly onCrop?: () => void;
  readonly onDelete?: () => void;
  readonly onUpdatePrivacy?: (isPrivate: boolean) => void;
}

const ImagePreviewMenu: FC<Props> = ({ isPrivate, onEdit, onCrop, onDelete, onUpdatePrivacy }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleClose();
    onEdit?.();
  };

  const handleCrop = () => {
    handleClose();
    onCrop?.();
  };

  const handleDelete = () => {
    handleClose();
    onDelete?.();
  };

  if (!onEdit && !onDelete) {
    return null;
  }

  const onTogglePrivacy = () => {
    onUpdatePrivacy?.(!isPrivate);
  };

  return (
    <div>
      <Tooltip title={isPrivate ? "Prywatne" : "Publiczne"}>
        <IconButton onClick={onTogglePrivacy} size="small" sx={{ color: "white" }} data-testid="privacy-toggle">
          {isPrivate ? <Lock fontSize="small" /> : <LockOpen fontSize="small" />}
        </IconButton>
      </Tooltip>
      <IconButton
        id="image-preview-edit-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        aria-label="Akcje grafiki"
        sx={{ color: "white" }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <MoreIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "image-preview-edit-button",
          },
        }}
      >
        {onEdit && (
          <MenuItem onClick={handleEdit}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Edytuj</ListItemText>
          </MenuItem>
        )}
        {onCrop && (
          <MenuItem onClick={handleCrop}>
            <ListItemIcon>
              <CropIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Kadruj 16:9</ListItemText>
          </MenuItem>
        )}
        {onDelete && (
          <MenuItem onClick={handleDelete}>
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Usuń</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default ImagePreviewMenu;
